import { IPreloaderConfiguration } from '@GFTypes/GameStoreTypes/PreloaderConfiguration';

export const PRELOADER_CONFIGURATION_DEFAULTS: IPreloaderConfiguration = {
    preloaderItems: []
};
